var _defs, _path, _g, _path2, _polygon, _polygon2, _polygon3, _g2, _path3, _path4, _g3, _path5, _g4, _polygon4, _polygon5, _path6, _path7, _polygon6, _g5, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdlineGreenIii(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 397.8 38.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#439539;}.cls-2{fill:#fff;}.cls-3{stroke:#0055a0;stroke-miterlimit:10;stroke-width:2px;}.cls-3,.cls-4{fill:none;}.cls-5{clip-path:url(#clippath-2);}.cls-6{fill:#0055a0;}.cls-7{clip-path:url(#clippath-1);}.cls-8{clip-path:url(#clippath);}.cls-9{clip-path:url(#clippath-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 216.6,
    height: 30.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 216.6,
    height: 30.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 216.6,
    height: 30.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 216.6,
    height: 30.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.9,16.4c0,3.9-3.2,7.2-7.1,7.2s-7.2-3.2-7.2-7.1h0c0-6.2,7.1-6.8,7.1-16.5,0,9.6,7.2,10.3,7.2,16.4Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397.8,16.4c0,3.9-3.2,7.2-7.1,7.2s-7.2-3.2-7.2-7.1h0c0-6.2,7.1-6.8,7.1-16.5,0,9.6,7.2,10.3,7.2,16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M395.8,17.3c-.2,0-.5,.2-.5,.4-.3,1.6-1.6,2.8-3.3,3-.2,0-.4,.2-.4,.5,0,.2,.2,.4,.4,.4h0c2.1-.2,3.8-1.8,4.1-3.8,.1-.2-.1-.4-.3-.4,.1-.1,0-.1,0-.1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.9,17.3c-.2,0-.5,.2-.5,.4-.3,1.6-1.6,2.8-3.3,3-.2,0-.4,.2-.4,.5,0,.2,.2,.4,.4,.4h0c2.1-.2,3.8-1.8,4.1-3.8,.1-.2-.1-.4-.3-.4,.1-.1,0-.1,0-.1Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "202.7 30.4 194 30.4 194 .2 202.7 .2 202.7 30.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "147.8 30.4 139.3 30.4 139.3 0 147.8 0 147.8 30.4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "125.6 30.4 117.4 30.4 117.4 .3 125.6 .3 125.6 30.4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "10.8 30.4 0 30.4 0 .3 10.8 .3 10.8 30.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23.4,3.9c2,2.9,1.5,7.8,0,10.8-1.9,3.7-6.5,3.5-10.4,3.5V.3c4.2-.4,8.4,.1,10.4,3.6Z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.3,19l.4,.8c3.3,3.5,6.6,7.1,9.9,10.6h-11.8V8.7h9.9l-8.4,10.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169,12.3c2.3,3.5,2.4,8.8,.7,12.7-1.2,3.2-4.9,5.2-8.6,5.5l-.1-22.2c3.3-.3,6.4,1.3,8,4Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "191.9 18.5 182.6 8.7 191.9 8.7 191.9 18.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182,27.5c.1,.3,.3,.7,.7,.7,3.8,.3,7.2-2.1,9-5.1-.1,1.7,.8,4.2-1.4,5-3.1,2.2-7.9,3.3-11.7,1.7-3.7-1.7-6.2-5.3-6.4-9.3-.3-4.1,1-8,4.4-10.3,1.6-.8,3.4-1.2,5.2-1.3l.2,18.6h0Z"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.3,30.4c-3.3-.3-6.7-1.4-8.3-4.4-2.2-4-2.2-8.9-.1-12.9,1.6-3.1,4.9-4.9,8.3-4.7V30.4h.1Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.5,11.1c1.7,2.1,2.2,5,2.2,8h-8V8.5c2.2,.1,4.5,.6,5.8,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.7,27.8c.7,.8,2,.5,3,.4,3.1-.5,5.2-3,6.8-5.2v3.3c-2.6,3.4-7,4.9-11.1,3.9-4.1-.9-7.2-4.2-7.8-8.3-.9-4.6,.9-9.4,4.6-12.2,1.4-.8,3-1.1,4.6-1V27.8h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M42.6,9.5c.8,.9,1.2,2.1,1.2,3.3s-.6,2.3-1.5,3c-1.2,.9-2.8,1.2-4.3,.7-1.4-.6-2.3-1.9-2.6-3.4-.2-1.5,.4-3,1.7-3.9,1.7-1.2,4-1,5.5,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136,12.2c2.1,4.3,2.3,9.2,.6,13.6-1.3,3.2-4.9,4.7-8.5,4.5h-.2V8.8c3.1-.1,6.5,.9,8.1,3.4Z"
  })))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "84.4 30.4 76.1 30.4 76.1 8.8 84.4 8.8 84.4 30.4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "74 30.4 65.5 30.4 65.5 8.8 74 8.8 74 30.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.4,11.8c.7,1.6,.6,3.4,.6,5.3v13.4h-8.6V8.9c3.1-.1,6.8-.3,8,2.9h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.7,12.9c.5,5.7,.2,11.7,.3,17.6h-8.4l-.1-18.3c-.2-1.1-.8-2-1.7-2.7,3.7-1.4,8.3-.2,9.9,3.4Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "34.8 30.4 26.3 30.4 26.3 8.6 34.8 8.6 34.8 30.4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.4,12.2c.3,1,.3,2.1-.2,3-.8,1.5-2.3,2.4-4,2.4-1.8,0-3.5-1.2-4-3-.4-1.6,.1-3.3,1.4-4.4,1.3-1.1,3.1-1.3,4.6-.6,1,.5,1.8,1.5,2.2,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.2,30.4c-3.3,.1-6.9,.2-8.5-2.7-.9-1.7-1-3.7-.4-5.4,1.5-3.3,5.3-3.7,8.9-3.4v11.5Z"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.3,2.3c-.3-.1-.5-.2-.8-.1h-.6v1.4h.6c.2,0,.4,0,.7-.1s.4-.3,.4-.6c0-.2-.1-.5-.3-.6Zm-.7-.6c.3,0,.7,0,1,.1,.4,.2,.6,.6,.6,1,0,.3-.1,.6-.4,.8-.2,.1-.4,.2-.6,.2,.3,0,.5,.2,.7,.4,.1,.2,.2,.4,.2,.6v.8h-.5v-.6c0-.3-.1-.7-.4-.9-.2-.1-.5-.1-.8-.1h-.6v1.5h-.7V1.7h1.5Zm-2.1-.2c-.6,.6-.9,1.4-.9,2.2s.3,1.6,.9,2.2c1.2,1.2,3.1,1.2,4.4,0h0c.6-.6,.9-1.4,.9-2.2,0-1.7-1.4-3.1-3.1-3.1h-.1c-.8,0-1.6,.3-2.1,.9h0Zm4.7,4.7c-1.4,1.4-3.7,1.4-5.1,0-.7-.7-1-1.6-1-2.5,0-2,1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6c0,.9-.4,1.8-1.1,2.5h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.4,38.8c-3.5,0-6.5-1.5-9.2-5l3.6-2.8c1.8,2.3,3.6,3.1,5.8,3.1,3,.2,5.7-2.1,5.9-5.2v-.3c-1.7,1.3-3.7,2-5.9,2-6.1,0-11-4.9-11-11s4.9-11,11-11c2.1,0,4.2,.7,5.9,2v-1.7h5V27.6c.1,6-4.6,11-10.6,11.1-.2,.1-.4,.1-.5,.1Zm.3-25.6c-3.3,0-5.8,2.8-5.8,6.4s2.5,6.4,5.8,6.4,5.8-2.8,5.8-6.4-2.5-6.4-5.8-6.4h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.9,20.1v10.2h-5V8.9h5v2.1c1.8-1.7,3.5-2.3,6.6-2.5v4.7c-5.1,.6-6.6,3.8-6.6,6.9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.1,21.5h-15.9c.3,2.5,3,4.4,5.5,4.4,2.3-.1,4.4-1.2,5.9-2.9l3.4,3.1c-2.3,2.8-5.6,4.4-9.2,4.5-6.1,0-11-4.9-11-11s4.9-11,11-11h0c5.8-.1,10.6,4.6,10.6,10.4v.4c-.1,.8-.3,2.1-.3,2.1Zm-10.4-8.3c-2.5,0-4.7,1.6-5.5,3.9h10.5c-.5-2.3-2.6-3.9-5-3.9Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314,21.5h-15.9c.3,2.5,3,4.4,5.5,4.4,2.3-.1,4.4-1.1,5.9-2.9l3.4,3.1c-2.3,2.8-5.7,4.4-9.3,4.4-6.1,0-11-4.9-11-11s4.9-11,11-11,10.6,4.6,10.6,10.5v.4c0,.7-.1,1.4-.2,2.1Zm-10.4-8.3c-2.5,0-4.7,1.6-5.5,3.9h10.5c-.5-2.3-2.6-3.9-5-3.9Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.7,30.2v-12.4c0-3-1.8-4.6-4.3-4.6s-4.4,1.8-4.4,4.7v12.3h-5V8.9h5v1.4c1.6-1.2,3.5-1.8,5.5-1.7,4.9,0,8.2,3.4,8.2,8.9v12.8h-5v-.1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.9,16.4c0,3.9-3.2,7.2-7.1,7.2s-7.2-3.2-7.2-7.1h0c0-6.2,7.1-6.8,7.1-16.5,0,9.6,7.2,10.3,7.2,16.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.9,17.3c-.2,0-.5,.2-.5,.4-.3,1.6-1.6,2.8-3.3,3-.2,0-.4,.2-.4,.5,0,.2,.2,.4,.4,.4h0c2.1-.2,3.8-1.8,4.1-3.8,.1-.2-.1-.4-.3-.4,.1-.1,0-.1,0-.1Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 361.46,
    y1: 0.29,
    x2: 361.46,
    y2: 25.79
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdlineGreenIii);
export default __webpack_public_path__ + "static/media/prodline_greenI+II.950e78aa7c9bb4936824b67aede31c7e.svg";
export { ForwardRef as ReactComponent };